<app-time-range-tail-config *ngFor="let item of entityTailConfigs; let index = index;"
                            [entityTailConfig]="item" [entityList]="legalEntityList"
                            (copyToAnotherEntity)="onCopyToAnotherEntity($event, index)">
</app-time-range-tail-config>
